import { render } from "./ToolMenu.vue?vue&type=template&id=1bc7dfe2"
import script from "./ToolMenu.vue?vue&type=script&lang=js"
export * from "./ToolMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__